const queryString = require('query-string');

export const fetchQueryString = (name: string) => {
    try {
        return queryString.parse(window.location.href.split('?')[1])[name]
    } catch (error) {
        return null
    }
}